import useGrantedAuthScopes from '../useGrantedAuthScopes'

// The KI-Zugriff feature switch, same permission the backend's ai-access
// router and the MCP server require (`access:ai`, granted via Auth0 RBAC).
const AI_SCOPE = 'access:ai'

interface AiPermissionState {
  hasAiPermission: boolean
  isLoading: boolean
}

const useHasAiPermission = (): AiPermissionState => {
  const { grantedScopes, isLoading } = useGrantedAuthScopes()

  return {
    hasAiPermission: grantedScopes.includes(AI_SCOPE),
    isLoading,
  }
}

export default useHasAiPermission
